import { useEffect, useState } from "react"

function useDebounce(value, delay) {
	// State and setters for debounced value
	const [debouncedValue, setDebouncedValue] = useState(value)
	useEffect(
		() => {
			// Update debounced value after delay
			const timeoutId = setTimeout(() => {
				setDebouncedValue(value)
			}, delay)
			return () => {
				clearTimeout(timeoutId)
			}
		},
		[value, delay] // Only re-call effect if value or delay changes
	)
	return debouncedValue
}

export default useDebounce
